export default __webpack_public_path__ + "static/media/Rich Table (5).8788700a.png";